import { API } from "..";
import { API_QC_PROCESS_MONITOR } from "../URL";

const QcAPI = {
  monitorList: (body: any, paging: any) => {
    return API.post(
      `${API_QC_PROCESS_MONITOR}?page=${paging.pageIndex}&per_page=${paging.pageSize}`,
      body
    );
  },
};

export default QcAPI;
